import { setupHazetTracking } from '../tracking'
import { IShopServices } from '@core/config/services'
import setupConverlyticsTracking from '@core/modules/converlytics-tracking'

export default function initCustom(services: IShopServices) {
  setupHazetTracking(services)
  setupConverlyticsTracking(services)
}
